import { useState } from "react";


export const useDeleteOcrAccountStates = () => {
  const [ocrAccountId, setOcrAccountId] = useState("");

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    ocrAccountId,
    setOcrAccountId,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
